module.exports = __webpack_public_path__ + "img/logo.3d3cc317.png";